import { Component } from '@theme/component';

/**
 * Opens the page's `customer-faq` section on a topic or with a search query.
 * Root of the Kundenservice hero and topic cards; controls carry
 * `data-faq-topic` (metaobject handle) or `data-faq-search` and call
 * `on:click="/open"`. Without JS (or without an FAQ on the page) the links
 * fall back to their native behaviour. The hero search box is its own
 * component (ks-hero-search).
 */
class KsFaqTrigger extends Component {
  /** @param {Event} event */
  open = (event) => {
    const control = event.target;
    if (!(control instanceof HTMLElement)) return;
    const { faqTopic: topic = '', faqSearch: search = '' } = control.dataset;
    if (!topic && !search) return;
    if (!this.#hasFaq()) return;

    event.preventDefault();
    this.#dispatch({ topic, search }, control.textContent?.trim() ?? '');
  };

  #hasFaq() {
    return document.querySelector('customer-faq-component') !== null;
  }

  /**
   * @param {{ topic: string, search: string }} detail
   * @param {string} label
   */
  #dispatch(detail, label) {
    document.dispatchEvent(new CustomEvent('customer-faq:open', { detail }));
    window.phCapture?.('kundenservice_faq_shortcut_clicked', {
      source: this.dataset.source || null,
      topic: detail.topic || null,
      search: detail.search || null,
      label,
    });
  }
}

if (!customElements.get('ks-faq-trigger')) {
  customElements.define('ks-faq-trigger', KsFaqTrigger);
}
